import bloodworks1 from "../asset/images/BloodWorks/BloodWorks_Home.jpg";
import bloodworks2 from "../asset/images/BloodWorks/BloodWorks_BloodBank.jpg";
import bloodworks3 from "../asset/images/BloodWorks/BloodWorks_Event.jpg";
import bloodworks4 from "../asset/images/BloodWorks/BloodWorks_UserDashSettings.jpg";

import dodgeBlock1 from "../asset/images/Dodge_Block/DodgeBlock_Home.png";
import dodgeBlock2 from "../asset/images/Dodge_Block/DodgeBlock_HowToPlay.png";
import dodgeBlock3 from "../asset/images/Dodge_Block/DodgeBlock_GamePlay.png";
import dodgeBlock4 from "../asset/images/Dodge_Block/DodgeBlock_ResultScreen.png";

import diceduel1 from "../asset/images/Dice_Duel/DiceDuel_Home.png";
import diceduel2 from "../asset/images/Dice_Duel/DiceDuel_PointLimitSetter.png";
import diceduel4 from "../asset/images/Dice_Duel/DiceDuel_GamePlay1.png";
import diceduel5 from "../asset/images/Dice_Duel/DiceDuel_GamePlay2.png";
import diceduel3 from "../asset/images/Dice_Duel/DiceDuel_PlayScreen.png";
import diceduel6 from "../asset/images/Dice_Duel/DiceDuel_Result.png";

import numguesser1 from "../asset/images/Num_Guesser/Num_Guesser_PlayScreen.png";
import numguesser2 from "../asset/images/Num_Guesser/Num_Guesser_GamePlay.png";
import numguesser3 from "../asset/images/Num_Guesser/Num_Guesser_HintLower.png";
import numguesser4 from "../asset/images/Num_Guesser/Num_Guesser_HintHigher.png";
import numguesser5 from "../asset/images/Num_Guesser/Num_Guesser_CorrectGuess.png";

import tictactoe1 from "../asset/images/Tic_Tac_Toe/TicTacToe_PlayScreen.png";
import tictactoe2 from "../asset/images/Tic_Tac_Toe/TicTacToe_GameStart.png";
import tictactoe3 from "../asset/images/Tic_Tac_Toe/TicTacToe_XTurn.png";
import tictactoe4 from "../asset/images/Tic_Tac_Toe/TicTacToe_OTurn.png";
import tictactoe5 from "../asset/images/Tic_Tac_Toe/TicTacToe_WinCase.png";
import tictactoe6 from "../asset/images/Tic_Tac_Toe/TicTacToe_TieCase.png";

import rockpaperscissor1 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_PVP.png";
import rockpaperscissor2 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_MoveChosen.png";
import rockpaperscissor3 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_WinnerCase.png";
import rockpaperscissor4 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_TieCase.png";
import rockpaperscissor5 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_PVP_Score.png";
import rockpaperscissor6 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_CVP.png";
import rockpaperscissor7 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_CVP_PWinCase.png";
import rockpaperscissor8 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_CVP_CWinCase.png";
import rockpaperscissor9 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_CVP_TieCase.png";
import rockpaperscissor10 from "../asset/images/Rock_Paper_Scissor/Rock_Paper_Scissor_CVP_Score.png";

import snakegame1 from "../asset/images/Snake_Game/Snake_Game_PlayScreen.png";
import snakegame2 from "../asset/images/Snake_Game/Snake_Game_GamePlay.png";
import snakegame3 from "../asset/images/Snake_Game/Snake_Game_GameOver.png";

import twozerofoureightgame1 from "../asset/images/2048/2048_PlayScreen.png";
import twozerofoureightgame2 from "../asset/images/2048/2048_GameStart.png";
import twozerofoureightgame3 from "../asset/images/2048/2048_GamePlay.png";
import twozerofoureightgame4 from "../asset/images/2048/2048_GameWon.png";
import twozerofoureightgame5 from "../asset/images/2048/2048_GameOver.png";

import merchVault1 from "../asset/images/MerchVault/MerchVault_Home.jpg";
import merchVault2 from "../asset/images/MerchVault/MerchVault_Customize.jpg";
import merchVault3 from "../asset/images/MerchVault/MerchVault_Artist.jpg";
import merchVault4 from "../asset/images/MerchVault/MerchVault_ProductPage.jpg";

import visuoFind1 from "../asset/images/VisuoFind/VisuoFind_Home.png";
import visuoFind2 from "../asset/images/VisuoFind/VisuoFind_SearchBox.png";
import visuoFind3 from "../asset/images/VisuoFind/VisuoFind_ViewResult.png";

import cinemaTracker1 from "../asset/images/CinemaTracker/CinemaTracker_HomePage.png";
import cinemaTracker2 from "../asset/images/CinemaTracker/CinemaTracker_HomePage_NowPlaying.png";
import cinemaTracker3 from "../asset/images/CinemaTracker/CinemaTracker_HomePage_PopularShows.png";
import cinemaTracker4 from "../asset/images/CinemaTracker/CinemaTracker_SearchDropDown.png";
import cinemaTracker5 from "../asset/images/CinemaTracker/CinemaTracker_Movies.png";
import cinemaTracker6 from "../asset/images/CinemaTracker/CinemaTracker_TvShows.png";
import cinemaTracker7 from "../asset/images/CinemaTracker/CinemaTracker_Trendings.png";
import cinemaTracker8 from "../asset/images/CinemaTracker/CinemaTracker_Genres.png";
import cinemaTracker9 from "../asset/images/CinemaTracker/CinemaTracker_Actors.png";
import cinemaTracker10 from "../asset/images/CinemaTracker/CinemaTracker_Favorites.png";
import cinemaTracker11 from "../asset/images/CinemaTracker/CinemaTracker_WatchList.png";
import cinemaTracker12 from "../asset/images/CinemaTracker/CinemaTracker_Footer.png";

import mssquiz1 from "../asset/images/MSSQuiz/MSSQuiz_GamePlayHome.png";
import mssquiz2 from "../asset/images/MSSQuiz/MSSQuiz_QuizSelect.png";
import mssquiz3 from "../asset/images/MSSQuiz/MSSQuiz_StartScreen.png";
import mssquiz4 from "../asset/images/MSSQuiz/MSSQuiz_QuestionOption.png";
import mssquiz5 from "../asset/images/MSSQuiz/MSSQuiz_Dashboard.png";
import mssquiz6 from "../asset/images/MSSQuiz/MSSQuiz_QuestionCreate.png";
import mssquiz7 from "../asset/images/MSSQuiz/MSSQuiz_QuestionList.png";
import mssquiz8 from "../asset/images/MSSQuiz/MSSQuiz_QuizCreate.png";
import mssquiz9 from "../asset/images/MSSQuiz/MSSQuiz_QuizRoundCreate.png";
import mssquiz10 from "../asset/images/MSSQuiz/MSSQuiz_QuizHistory.png";

import "../styles/Projects.css";

// import sampleImg from "../asset/gifs/bggg.gif";

export const allProjects = [
  {
    name: "Dodge Block",
    desc: "Dodge Block is a 3D single-player game built with Unity. Players control a car and must avoid falling blocks and obstacles to survive longer and achieve higher scores.",
    demo: "/unity-demo/index.html",
    img: [dodgeBlock1, dodgeBlock2, dodgeBlock3, dodgeBlock4],
    tags: ["C#", "Unity3D", "Blender"],
    type: "game",
  },
  {
    name: "Dice Duel",
    desc: "Dice Duel is an interactive two-player game where players take turns rolling a dice, accumulating points, and competing to reach the maximum score first. Built with HTML, CSS, and JavaScript, it features dynamic score tracking, progress bars, and a gaming-inspired UI.",
    demo: "/projects/Dice%20Game/dice-game.html",
    img: [diceduel1, diceduel2, diceduel3, diceduel4, diceduel5, diceduel6],
    tags: ["HTML", "CSS", "JavaScript"],
    type: "game",
  },
  {
    name: "Num Guesser",
    desc: "Num Guesser is an engaging number guessing game where players try to guess a randomly generated number. It features real-time hints, a high-score tracker, dynamic input validation, and a playful UI with colorful feedback. Built with HTML, CSS, and JavaScript for a fun and interactive experience.",
    demo: "/projects/Num%20Guesser/num-guesser.html",
    img: [numguesser1, numguesser2, numguesser3, numguesser4, numguesser5],
    tags: ["HTML", "CSS", "JavaScript"],
    type: "game",
  },

  {
    name: "Tic Tac Toe",
    desc: "Tic Tac Toe is an interactive two-player game where players take turns placing X and O on a 3x3 grid. It features turn-based gameplay, win detection with highlighted winning cells, tie detection, and a replay option. Built with HTML, CSS, and JavaScript, it offers a responsive and engaging UI for a fun gaming experience.",
    demo: "/projects/Tic%20Tac%20Toe/tic-tac-toe.html",
    img: [
      tictactoe1,
      tictactoe2,
      tictactoe3,
      tictactoe4,
      tictactoe5,
      tictactoe6,
    ],
    tags: ["HTML", "CSS", "JavaScript"],
    type: "game",
  },

  {
    name: "Rock Paper Scissor",
    desc: "Rock Paper Scissor is a fast-paced interactive game featuring both Player vs Player and Player vs Computer modes. It includes keyboard and button controls, real-time move display, win/tie detection, score tracking, and a clean responsive UI. Built with HTML, CSS, and JavaScript for an engaging gameplay experience. For Payer 1, Press Key: R for Rock, P for Paper and S fot Stone and, For Payer 1, Press Key: ⬅️ for Rock, ⬆️ for Paper and ➡️ fot Stone ",
    demo: "/projects/Rock%20Paper%20Scissor/rock_paper_scissor.html",
    img: [
      rockpaperscissor1,
      rockpaperscissor2,
      rockpaperscissor3,
      rockpaperscissor4,
      rockpaperscissor5,
      rockpaperscissor6,
      rockpaperscissor7,
      rockpaperscissor8,
      rockpaperscissor9,
      rockpaperscissor10,
    ],
    tags: ["HTML", "CSS", "JavaScript"],
    type: "game",
  },

  {
    name: "Snake Game",
    desc: "Snake Game is a classic arcade-style game where the player controls a growing snake, navigating it to eat food while avoiding collisions with walls and itself. It features continuous movement, score tracking, high score storage using localStorage, and both keyboard and on-screen controls. Built with HTML, CSS, and JavaScript, it offers a responsive and engaging UI for desktop and mobile devices.",
    demo: "/projects/Snake%20Game/snake_game.html",
    img: [snakegame1, snakegame2, snakegame3],
    tags: ["HTML", "CSS", "JavaScript"],
    type: "game",
  },

  {
    name: "2048 Game",
    desc: "2048 is a classic puzzle game where players slide numbered tiles on a 4×4 grid to combine matching values and reach the 2048 tile. The game features smooth tile movements, merge animations, score tracking with best score saved using localStorage, keyboard and on-screen controls, and win/game-over detection. Built with HTML, CSS, and JavaScript, it offers an intuitive and responsive gameplay experience.",
    demo: "/projects/2048%20Game/2048_game.html",
    img: [
      twozerofoureightgame1,
      twozerofoureightgame2,
      twozerofoureightgame3,
      twozerofoureightgame4,
      twozerofoureightgame5,
    ],
    tags: ["HTML", "CSS", "JavaScript"],
    type: "game",
  },

  {
    name: "Cinematracker",
    desc: "Cinematracker is a React.js-based platform that allows users to search for movies, TV shows, and actors. Users can add content to their favorites and manage a personalized watchlist, tracking the status of each show as Unwatched, Watching, or Watched. It helps users organize and keep track of all the movies and shows they want to follow.",
    link: "https://cinematracker.vercel.app/",
    img: [
      cinemaTracker1,
      cinemaTracker2,
      cinemaTracker3,
      cinemaTracker4,
      cinemaTracker5,
      cinemaTracker6,
      cinemaTracker7,
      cinemaTracker8,
      cinemaTracker9,
      cinemaTracker10,
      cinemaTracker11,
      cinemaTracker12,
    ],
    tags: ["React.js", "HTML", "CSS", "JavaScript"],
    type: "web",
  },

  {
    name: "MSSQuiz",
    desc: "Use Email: 'admintest123@example.com', password: 'test12345' to login as admin and create quiz and test the game as quiz master MSSQuiz is a complete quiz-management platform where admins can create quizzes, rounds, questions, and teams, while assigned Quiz Masters can host the game in real time. The system supports multiple round types including General (MCQ), Subjective (category-based), Rapid Fire (timed question streaks), Estimation (teams provide numerical estimates), and Buzzer (fastest buzz gets to answer). It also provides detailed quiz history, team performance tracking, and admin-level monitoring for smooth event execution. .",
    img: [
      mssquiz1,
      mssquiz2,
      mssquiz3,
      mssquiz4,
      mssquiz5,
      mssquiz6,
      mssquiz7,
      mssquiz8,
      mssquiz9,
      mssquiz10,
    ],
    link: "https://mssquizapp.vercel.app/",
    tags: ["HTML", "CSS", "React.js", "Node.js", "MongoDB"],
    type: "web",
  },
  {
    name: "MerchVault",
    desc: "MerchVault is an e-commerce platform for selling apparel such as t-shirts, hoodies, posters, and more. Users can customize products with graphics or text, and creators can upload and sell their own designs on the marketplace.",
    pdf: "/pdf/MerchVault.pdf",
    img: [merchVault1, merchVault2, merchVault3, merchVault4],
    tags: ["HTML", "CSS", "React.js", "Node.js", "MongoDB"],
    type: "web",
  },
  {
    name: "VisuoFind",
    desc: "VisuoFind is an AI-powered product search application that finds look-alike apparel from images. Users can upload a picture of an item—such as shoes, t-shirts, watches, etc.—and the system identifies visually similar products and displays accurate matches.",
    pdf: "/pdf/VisuoFind.pdf",
    img: [visuoFind1, visuoFind2, visuoFind3],
    tags: ["HTML", "CSS", "React.js", "Python", "Spring Boot", "PostgreSQL"],
    type: "web",
  },
  {
    name: "BloodWorks",
    desc: "BloodWorks is a platform that connects blood donors with people in need. Hospitals and organizations can also register to display their available donors and post blood donation events, helping increase participation and awareness.",
    pdf: "/pdf/BloodWorks.pdf",
    img: [bloodworks1, bloodworks2, bloodworks3, bloodworks4],
    tags: ["HTML", "CSS", "JavaScript", "PHP", "MySQL"],
    type: "web",
  },
];
